/**
 * Utility to clear cached object field definitions and page layouts
 *
 * Run this in browser console to clear the field cache:
 * import('./utils/clearFieldCache').then(m => m.clearFieldCache())
 */

export function clearFieldCache() {
  console.log('🧹 Clearing field and layout caches...');

  // Clear the persisted object fields from localStorage
  const fieldsCleared = localStorage.removeItem('crm_object_fields');
  console.log('  ✓ Cleared crm_object_fields');

  // Clear page layouts cache
  localStorage.removeItem('crm_page_layouts');
  console.log('  ✓ Cleared crm_page_layouts');

  // Clear object manager layouts
  localStorage.removeItem('crm_object_manager_layouts');
  console.log('  ✓ Cleared crm_object_manager_layouts');

  console.log('✅ Field cache and layouts cleared! Reloading page...');

  // Reload the page
  setTimeout(() => {
    window.location.reload();
  }, 500);
}

export function viewFieldCache() {
  const fields = localStorage.getItem('crm_object_fields');
  if (fields) {
    const parsed = JSON.parse(fields);
    const contactFields = parsed.filter((f: any) => f.objectId === 'obj_contact');
    const accountIdField = contactFields.find((f: any) => f.fieldName === 'accountId');

    console.log('📋 Contact accountId field:', accountIdField);
    console.log('   Field Type:', accountIdField?.fieldType);

    return accountIdField;
  } else {
    console.log('❌ No field cache found');
    return null;
  }
}

// Auto-execute if this module is imported directly
if (typeof window !== 'undefined') {
  // Make it available globally for easy console access
  (window as any).clearFieldCache = clearFieldCache;
  (window as any).viewFieldCache = viewFieldCache;
  console.log('💡 Available commands:');
  console.log('   - clearFieldCache() - Clear and reload');
  console.log('   - viewFieldCache() - Inspect accountId field type');
}
